var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevronRightSmall(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z",
    fill: "#e1087e",
    "data-name": "Layer 1"
  })));
}
export default SvgChevronRightSmall;